// libraries
import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

// specific components
import MaterialEntryButtonGrid from 'components/containers/inbound-tickets/components/MaterialEntryButtonGrid'
import MaterialEntryForm from 'components/containers/inbound-tickets/components/MaterialEntryForm'

// helpers and utils
import { SCALE_MATERIAL_VIEW_OPTIONS } from 'utils/constants'

const MaterialEntry = ({ materialEntryViewMode, materials, ...restProps }) => {
  const [activeMaterialForAxleWeights, setActiveMaterialForAxleWeights] = useState(null)
  const isViewingButtons = useMemo(
    () => materialEntryViewMode === SCALE_MATERIAL_VIEW_OPTIONS.BUTTONS,
    [materialEntryViewMode],
  )

  return (
    <Box
      sx={{ border: 1, borderColor: 'grey.400', borderRadius: 2, backgroundColor: 'background.section' }}
      p={2}
      mt={3}
    >
      {isViewingButtons ? (
        <MaterialEntryButtonGrid setActiveMaterialForAxleWeights={setActiveMaterialForAxleWeights} {...restProps} />
      ) : (
        <MaterialEntryForm
          materialEntryViewMode={materialEntryViewMode}
          activeMaterialForAxleWeights={activeMaterialForAxleWeights}
          setActiveMaterialForAxleWeights={setActiveMaterialForAxleWeights}
          materials={materials}
          {...restProps}
        />
      )}
    </Box>
  )
}

MaterialEntry.propTypes = {
  materialEntryViewMode: PropTypes.string,
  materials: PropTypes.array,
}

MaterialEntry.defaultProps = {
  materialEntryViewMode: SCALE_MATERIAL_VIEW_OPTIONS.BUTTONS,
  materials: [],
}

export default MaterialEntry
